import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Card from 'react-bootstrap/Card';
import Seminario from '../../../assets/images/seminario.svg';
import Seminario2 from '../../../assets/images/seminario2.svg';

import './styles.css';

const Estatuto = () => {
    const location = useLocation();

    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }, [location.pathname]);
    return (
        <div className="container">
            <div className="row">

                <div className="col-sm-12">
                    <div className='title'>
                        <h2>"Conectando com Valores: Ética, Honestidade, Compromisso e Conformidade."</h2>
                    </div>
                    <Card className="card">

                        <div className="container">
                            
                            <Card.Title></Card.Title>

                            <Card.Body>
                                <div className="content-info">
                                    <div className="image-info">
                                        <img src={Seminario} alt="Foto" />
                                        <img src={Seminario2} alt="Foto" />
                                    </div>
                                    <div className="info">

                                        <span>
                                            Na Gigabyte Telecom o compromisso é com nosso cliente.
                                            Estamos firmemente comprometidos em fornecer serviços de qualidade,
                                            confiáveis e inovadores, sempre pautados por valores fundamentais.<br /><br />

                                            Acreditamos que a ética é o alicerce de qualquer relacionamento sólido.
                                            Agimos com transparência, respeito e integridade em todas as nossas interações.
                                            Valorizamos a confiança que o cliente deposita em nós e nos esforçamos para mantê-la em cada interação.<br /><br />
                                            Honestidade é a base de nossa conduta. Buscamos ser transparentes em nossas comunicações e oferecer
                                            informações claras e precisas sobre nossos serviços. O cliente pode contar conosco para receber orientações
                                            objetivas e soluções personalizadas, sempre com total honestidade.<br /><br />

                                            Nosso compromisso com o cliente é absoluto. Trabalhamos incansavelmente para superar suas expectativas,
                                            oferecendo um atendimento excepcional e soluções eficientes para as necessidades de conectividade dos nossos clientes.
                                            Estamos comprometidos em fornecer serviços confiáveis, rápidos e seguros, para que o cliente possa desfrutar
                                            de uma experiência de internet superior.<br /><br />

                                            Além disso, a conformidade é um pilar essencial em nossa empresa. Seguimos rigorosamente as normas
                                            e regulamentações do setor, garantindo que nossos serviços sejam prestados de acordo com os mais
                                            altos padrões de qualidade e segurança. Nossa dedicação à conformidade assegura que a experiência
                                            com nossa empresa seja confiável e em conformidade com as melhores práticas do mercado.<br /><br />

                                            Na Gigabyte Telecom, estamos comprometidos com a satisfação do cliente. A confiança em nossos
                                            serviços é a força motriz por trás de tudo o que fazemos. Conte conosco para uma conexão confiável,
                                            serviços excepcionais e um compromisso inabalável com os valores de ética, honestidade, compromisso
                                            e conformidade. Estamos aqui para proporcionar a melhor experiência de conectividade, hoje
                                            e no futuro.
                                        </span>
                                    </div>
                                </div>
                            </Card.Body>
                        </div>
                    </Card>

                </div>
            </div>
        </div>
    )
}
export default Estatuto;